import React, {useEffect, useState} from "react";
import { Box, Button, CardActions, CardContent, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import {useDispatch} from "react-redux";
import {deleteGroup, saveGroup} from "../../store/walletSlice";
import WalletIcon from "../layout/WalletIcon";
import ViewAndEditFormLayout from "./ViewAndEditFormLayout";
import {useTranslation} from "react-i18next";



const EditGroupForm = ({group, onCancel, resetTrigger}) => {
    const {t} = useTranslation();
    const DEFAULT_ERROR = {name: null, image: null};

    const dispatch = useDispatch();
    const [name, setName] = useState(group.name);
    const [errors, setErrors] = useState(DEFAULT_ERROR);
    const [imageId, setImageId] = useState(group.image ? group.image.id : 1);


    useEffect(() => {
        setName(group.name);
        setImageId(group.image ? group.image.id : 1);

        setErrors(DEFAULT_ERROR);
    }, [group, resetTrigger]);

    const handleNameChanged = (newName) => {
        setName(newName);
        setErrors({...errors, name: null})
    }

    const handleSave = () => {
        if(validateForm()) {
            dispatch(saveGroup({...group, name: name, image: {id: imageId}}, () => onCancel()))
        }
    }

    const validateForm = () => {
        const newErrors = {
            name: !name.trim() ? "Name is required" : null,
            image: !imageId ? "Image selection is required" : null
        }
        setErrors(newErrors);
        return !(newErrors.name || newErrors.image);
    }

    const editContent = ({ onCancel: handleCancel, onSave: handleSaveLayout }) => (
        <>
            <CardContent>
                <Box sx={{ paddingLeft: "12px", mt: 2 }}>
                    <TextField
                        id="name"
                        value={name}
                        onChange={(e) => handleNameChanged(e.target.value)}
                        label={t("common.labels.name")}
                        variant="standard"
                        sx={{ width: "50%" }}
                        error={errors.name}
                        helperText={errors.name}
                    />
                </Box>
                <Box sx={{ mt: 4 }}>
                    <FormControl sx={{ width: "40%", paddingLeft: "12px" }}>
                        <InputLabel id="wallet-currency-select-label">{t("common.labels.image")}</InputLabel>
                        <Select
                            value={imageId}
                            variant="standard"
                            labelId="wallet-currency-select-labe"
                            onChange={(event) => {
                                setImageId(event.target.value);
                                setErrors({...errors, image: null});
                            }}
                            renderValue={val => (
                                <Box sx={{ position: "relative", height: 10 }}>
                                    {imageId ? (
                                        <WalletIcon image={{ id: imageId }} sx={{ position: "absolute", top: -7, left: -1 }} fontSize="large" />
                                    ) : (
                                        ""
                                    )}
                                </Box>
                            )}
                        >
                            {/*<Box>*/}
                            <MenuItem value={1} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 1 }} /></MenuItem>
                            <MenuItem value={2} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 2 }} /></MenuItem>
                            <MenuItem value={3} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 3 }} /></MenuItem>
                            <MenuItem value={4} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 4 }} /></MenuItem><br />
                            {/*</Box>*/}
                            {/*<Box>*/}
                            <MenuItem value={5} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 5 }} /></MenuItem>
                            <MenuItem value={6} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 6 }} /></MenuItem>
                            <MenuItem value={7} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 7 }} /></MenuItem>
                            <MenuItem value={8} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 8 }} /></MenuItem><br />
                            {/*</Box>*/}
                            {/*<Box>*/}
                            <MenuItem value={9} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 9 }} /></MenuItem>
                            <MenuItem value={10} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 10 }} /></MenuItem>
                            <MenuItem value={11} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 11 }} /></MenuItem>
                            <MenuItem value={12} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 12 }} /></MenuItem><br />
                            {/*</Box>*/}
                            {/*<Box>*/}
                            <MenuItem value={13} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 13 }} /></MenuItem>
                            <MenuItem value={14} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 14 }} /></MenuItem>
                            <MenuItem value={15} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 15 }} /></MenuItem>
                            <MenuItem value={16} sx={{ display: "inline-block" }}><WalletIcon image={{ id: 16 }} /></MenuItem>
                            {/*</Box>*/}
                        </Select>
                        {errors.image && <Typography variant="caption" color="error">{errors.image}</Typography>}
                    </FormControl>
                </Box>
            </CardContent>
            <CardActions sx={{ ml: "2rem", mb: "1rem", mt: "1rem", mr: "2rem", height: "4rem" }}>
                <Box sx={{ position: "relative", width: "100%" }}>
                    <Box sx={{ position: "absolute", left: 0 }}>
                        <Button variant="outlined" sx={{ mr: "1rem" }} onClick={handleCancel}>{t("common.buttons.cancel")}</Button>
                        <Button variant="contained" onClick={handleSaveLayout}>{t("common.buttons.save")}</Button>
                    </Box>
                    {group.id && (
                        <Box sx={{ position: "absolute", right: 0 }}>
                            <Button variant="outlined" color="error" onClick={() => dispatch(deleteGroup(group, () => onCancel()))}>
                                {t("common.buttons.delete")}
                            </Button>
                        </Box>
                    )}
                </Box>
            </CardActions>
        </>
    );

    return (
        <ViewAndEditFormLayout
            editTitle={group.id ? t("forms.group.editTitle") : t("forms.group.createTitle")}
            viewTitle={group.id ? t("forms.group.editTitle") : t("forms.group.createTitle")}
            initialEdit={true}
            onCancel={onCancel}
            onSave={handleSave}
            onDelete={group.id ? () => dispatch(deleteGroup(group, () => onCancel())) : undefined}
            editContent={editContent}
            viewContent={null}
        />
    );
}

export default EditGroupForm